import React from 'react';

//CORE COMPONENTS
import { styled } from '../../../components-core/packages/components-core/dist/theme-provider/index';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';

//STYLE
import { Text, TextAppearance, TextAlignment} from '../../../components-core/packages/components-core/dist/text';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';
import BroschureText from './BroschureText';


const UnorderedList = styled.div`
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(4, 1fr);
    list-style: none;

    @media screen and (max-width: 560px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const ClickableDiv = styled.div`
    cursor: pointer;
`;


class BroschureDownload extends React.Component {

    renderImages() {
        return sampleData.map(data => 
            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center} 
                verticalAlign={ContainerVerticalAlignment.center} 
                gutter={ContainerGutter.dynamic0100}
                wrap={ContainerWrap.always}
            >
                <ClickableDiv onClick={() => window.open('https://testvwticari.vw.com.tr/vwticari_files/2020_fiyat_listesi.pdf')}>
                    <Image src={data.link} alt={data.title} />
                    <Text 
                        appearance={TextAppearance.headline0200}
                        textAlign={TextAlignment.center}
                        bold
                    >
                        {data.title}
                    </Text>
                </ClickableDiv>
            </Container>    
            
        )
    }

    render() {
        return (
            <Container>
            <BroschureText/>
            <Container padding={containerPadding} stretchContent={true}>
                <UnorderedList>
                    {this.renderImages()}
                </UnorderedList>
            </Container>
            </Container>
        )
    }
}

const sampleData = [
    {
        title: 'Caddy',
        link: require('../../images/models/caddy.png') 
    },
    {
        title: 'Amarok',
        link: require('../../images/models/amarok.png')
    },
    {
        title: 'Transporter',
        link: require('../../images/models/transporter.png')
    },
    {
        title: 'Caravelle',
        link: require('../../images/models/transporter.png')
    },
    {
        title: 'Crafter',
        link: require('../../images/models/crafter.png')
    }
]

const containerPadding = {
    left: ContainerPadding.grid002,
    right: ContainerPadding.grid002
}

export default BroschureDownload;